import EmailList from './EmailList';

const EmailPage = {
    name: 'Email',
    list: EmailList
};
export default EmailPage;
